module.exports = __webpack_public_path__ + "img/img19.101d6834.svg";